import { Tooltip } from '@mui/material';
import React from 'react'

export const showWithToolTip = (params: any) => (
    <Tooltip title={params.value || ''}>
      <span className="MuiDataGrid-cellContent">{params.value}</span>
    </Tooltip>
  );